import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
/* 
const firebaseConfig = {
    apiKey: "AIzaSyAQF_EKxqaV4v3wJswHYMejC5QbY0FA--8",
    authDomain: "chaashnicouture-dc49a.firebaseapp.com",
    projectId: "chaashnicouture-dc49a",
    storageBucket: "chaashnicouture-dc49a.appspot.com",
    messagingSenderId: "249891158922",
    appId: "1:249891158922:web:50155856a6f586c9836673",
    measurementId: "G-7VENDNCQ9K"
  };
 */

/*   const firebaseConfig = {
    apiKey: "AIzaSyDuB9cQHmjznS8KCsKlDbCHZb4xNTRfqtA",
    authDomain: "wpx-product.firebaseapp.com",
    projectId: "wpx-product",
    storageBucket: "wpx-product.appspot.com",
    messagingSenderId: "552966328077",
    appId: "1:552966328077:web:1254cfb96d81bd1163ea44",
    measurementId: "G-0KDHYLWXVG"
  }; */

  const firebaseConfig = {
    apiKey: "AIzaSyAQF_EKxqaV4v3wJswHYMejC5QbY0FA--8",
    authDomain: "chaashnicouture-dc49a.firebaseapp.com",
    projectId: "chaashnicouture-dc49a",
    storageBucket: "chaashnicouture-dc49a.appspot.com",
    messagingSenderId: "249891158922",
    appId: "1:249891158922:web:50155856a6f586c9836673",
    measurementId: "G-7VENDNCQ9K"
  };
const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);